import { Analytics } from 'aws-amplify';

export async function recordAnalyticsEvent (eventName, body) {
  return Analytics.record({
    name: eventName,
    attributes: {
      ...body,
      source: 'io.uruk.app'
    }
  });
}
